<template>
  <ul class="links-line" v-if="data">
    <styledLinkrapper
      :hoverColor="currentTheme().select_color"
      class="links-list"
      v-for="(link, k) in data"
      :key="k"
    >
      <AcfLink :data="link.link" />
      <StyledIcon
        :iconsColor="theme.icons"
        class="icon"
        v-html="svgIcons.arrow2"
      />
    </styledLinkrapper>
  </ul>
</template>

<script>
import AcfLink from "@/components/elements/AcfLink";
import StyledIcon from "@/components/elements/StyledIcon";

import styled from "vue-styled-components";

const wrapperProps = { hoverColor: String };
const styledLinkrapper = styled("li", wrapperProps)`
  ${props =>
    props.hoverColor && props.hoverColor !== ""
      ? "a:hover{ color: " + props.hoverColor + "}"
      : ""};
`;

export default {
  name: "links-link",
  props: ["data"],
  computed: {
    theme() {
      return {
        text: "",
        icons: this.currentTheme().select_color
      };
    }
  },
  components: {
    AcfLink,
    StyledIcon,
    styledLinkrapper
  }
};
</script>

<style lang="scss">
.links-line {
  margin: 20px 0 0 0;
  list-style: none;
  padding: 0;
  a,
  .icon {
    display: inline-block;
  }
  a {
    color: inherit;
    text-decoration: none;
    font-weight: 700;
  }
  .links-list {
    display: inline-flex;
  }
  .icon {
    margin-top: 2px;
    margin-left: 10px;
    margin-right: 20px;
  }
}
</style>
